import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import './rich-editor.css';

export default () => {
    let editor;

    return {
        init() {
            const textarea = this.$el.querySelector('textarea');
            const mountEl = this.$refs.editorMount;

            if (!textarea || !mountEl) return;

            editor = new Editor({
                element: mountEl,
                extensions: [
                    StarterKit.configure({
                        strike: false,
                        code: false,
                        codeBlock: false,
                        heading: false,
                        blockquote: false,
                        horizontalRule: false,
                        link: false,
                        underline: false,
                    }),
                    Underline,
                    Link.configure({
                        openOnClick: false,
                        protocols: ['http', 'https'],
                    }),
                ],
                content: textarea.value || '',
                onTransaction: () => {
                    // Update reactive timestamp so Alpine re-evaluates toolbar active states
                    this._ts = Date.now();
                },
                onUpdate: ({editor}) => {
                    textarea.value = editor.getHTML();
                },
            });

            // Expose editor on the DOM element so communication-modal.js can access it
            this.$el._tiptapEditor = editor;

            // Sync editability with the card's enable/disable checkbox
            const card = this.$el.closest('.card');
            const checkbox = card?.querySelector('.card-header input[type="checkbox"]');
            if (checkbox) {
                editor.setEditable(checkbox.checked);
                checkbox.addEventListener('change', () => {
                    editor.setEditable(checkbox.checked);
                });
            }
        },

        destroy() {
            editor?.destroy();
        },

        isActive(format, attrs) {
            this._ts; // Access to create Alpine reactive dependency
            return editor?.isActive(format, attrs ?? {}) ?? false;
        },

        toggleBold() {
            editor?.chain().focus().toggleBold().run();
        },

        toggleItalic() {
            editor?.chain().focus().toggleItalic().run();
        },

        toggleUnderline() {
            editor?.chain().focus().toggleUnderline().run();
        },

        toggleBulletList() {
            editor?.chain().focus().toggleBulletList().run();
        },

        toggleOrderedList() {
            editor?.chain().focus().toggleOrderedList().run();
        },

        setLink() {
            if (!editor) return;
            const previousUrl = editor.getAttributes('link').href ?? '';
            const url = window.prompt('URL du lien :', previousUrl || 'https://');
            if (url === null) return;
            if (url === '') {
                editor.chain().focus().extendMarkRange('link').unsetLink().run();
            } else {
                editor.chain().focus().extendMarkRange('link').setLink({href: url}).run();
            }
        },

        insertText(token) {
            editor?.chain().focus().insertContent(token).run();
        }
    }
};
